import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { EGZAMIN, GRUPY, PATENT_PO_SLUGU, maDzial } from '../data/patenty';
import JsonLd from '../seo/JsonLd';
import { breadcrumbJsonLd } from '../seo/siteMeta';
import styles from '../css/modules/Nauka.module.css';

/** Rozdroże trybu nauki: wybór działu egzaminacyjnego dla danego patentu. */
const StudyHub = () => {
  const { patent: patentSlug } = useParams();
  const patent = PATENT_PO_SLUGU[patentSlug];

  if (!patent) {
    return (
      <div className={styles.wrap}>
        <h1 className={styles.h1}>Nie znamy takiego patentu</h1>
        <Link className={styles.cta} to="/">Wróć na stronę główną</Link>
      </div>
    );
  }

  // Sternik motorowodny nie ma na egzaminie teorii żeglowania - nie pokazujemy
  // działu, w którym i tak nie ma dla niego pytań.
  const grupy = GRUPY.filter(g => maDzial(patentSlug, g.slug));

  return (
    <div className={styles.wrap}>
      <JsonLd data={breadcrumbJsonLd([
        { name: 'Strona główna', path: '/' },
        { name: patent.nazwa, path: `/${patent.slug}` },
        { name: 'Nauka według działów', path: `/nauka/${patent.slug}` },
      ])} />

      <nav className={styles.breadcrumbs}>
        <Link to="/">Strona główna</Link> / <Link to={`/${patent.slug}`}>{patent.nazwa}</Link> / Nauka
      </nav>

      <h1 className={styles.h1}>Nauka do patentu {patent.dopelniacz}</h1>
      <p className={styles.lead}>
        Materiał podzielony na działy egzaminacyjne. W trybie nauki od razu widzisz, czy
        odpowiedź jest poprawna, wraz z wyjaśnieniem i podstawą prawną. Kiedy poczujesz się
        pewnie, sprawdź się w warunkach egzaminu: {EGZAMIN.pytan} pytań w {EGZAMIN.minut} minut.
      </p>

      <div className={styles.kafle}>
        {grupy.map(g => (
          <Link key={g.slug} to={`/nauka/${patent.slug}/${g.slug}`} className={styles.kafel}>
            <span className={styles.kafelUdzial}>{g.udzial} z {EGZAMIN.pytan} pytań egzaminu</span>
            <span className={styles.kafelNazwa}>{g.nazwa}</span>
            <span className={styles.kafelOpis}>{g.opis}</span>
          </Link>
        ))}
      </div>

      <div className={styles.akcje}>
        <Link className={styles.cta} to={`/egzamin/${patent.slug}`}>Przejdź do egzaminu próbnego</Link>
      </div>
    </div>
  );
};

export default StudyHub;
